@import 'styles/mixins';
@import '../_v4FormLayout';

.content {
  @include v4-content(1100px);
}

.mainRow {
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

.left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-right: clamp(0px, 3%, 40px);
}

.heading {
  font-weight: 400;
}

.groups {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.groupLabel {
  margin: 0;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--dark-90);
}

.pills {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.pill {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 8px;
  gap: 0;
  background: var(--dark-2);
  border: 1px solid var(--dark-4);
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.12s ease, background 0.12s ease;
  font-family: Sohne, sans-serif;
  color: var(--dark-90);

  &:hover {
    border-color: var(--dark-30);
  }
}

.pillReadOnly {
  cursor: default;

  &:hover {
    border-color: var(--dark-4);
  }
}

.pillSelected {
  border-color: var(--dark-90);
  color: var(--dark-90);
  background: var(--light-100);

  .pillLabel {
    font-weight: 500;
  }

  &:hover {
    border-color: var(--dark-90);
    color: var(--dark-90);
  }
}

.pillIcon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pillLabel {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
  padding-left: 4px;
  padding-right: 8px;
  padding-bottom: 1px;
}

.pillCheck {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--dark-90);
  color: var(--light-100);
  flex-shrink: 0;
}

.schedulePills {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.scheduleChip {
  --chip-color: var(--dark-90);
  --chip-background-color: var(--dark-2);
  --chip-border-color: var(--dark-4);
  --chip-background-color-hover: var(--dark-4);
  --chip-color-hover: var(--dark-90);
  --chip-border-color-hover: var(--dark-30);
  --chip-color-active: var(--dark-90);
  --chip-background-color-active: var(--light-100);
  --chip-border-color-active: var(--dark-90);

  &#{&} {
    height: 36px;
    border: 1px solid var(--chip-border-color);
    box-shadow: none;
    border-radius: 8px;
    font-family: Sohne, sans-serif;
    font-size: 16px;
    font-weight: 400;
    padding: 0 8px;
  }

  &[aria-checked='true'] {
    border-color: var(--chip-border-color-active);
    font-weight: 500;
  }
}

.sidebar {
  flex-shrink: 0;
  width: 290px;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 46px;
}

@include v4-sidebar-text;

.sidebarTextBlock {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sidebarHeadline {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: 0.16px;
  color: var(--dark-80);
}

@include for-phone-only {
  .scrollContainer {
    padding: 20px 20px 80px;
  }

  .content {
    gap: 0;
  }

  .mainRow {
    flex-direction: column;
  }

  .headerSection {
    gap: 0;

    h2 {
      font-size: 28px !important;
      line-height: 1.1 !important;
      letter-spacing: 0 !important;
      font-weight: 400 !important;
    }
  }

  .left {
    gap: 25px;
    padding-right: 0;
    width: 100%;
  }

  .groups {
    gap: 25px;
  }

  .group {
    gap: 8px;
  }

  .pills {
    gap: 6px;
  }

  .pill {
    height: auto;
    padding: 10px 8px;
    background: var(--dark-3);
    border: 1.5px solid var(--dark-4);
    border-radius: 10px;
  }

  .pillSelected {
    background: var(--light-100);
    border-color: var(--dark-90);

    .pillLabel {
      font-weight: 400;
    }
  }

  .pillIcon {
    width: 16px;
    height: 16px;

    svg {
      width: 15px;
      height: 15px;
    }
  }

  .pillLabel {
    padding-left: 2px;
    padding-right: 2px;
  }

  .pillCheck {
    display: none;
  }

  .schedulePills {
    column-gap: 10px;
    row-gap: 0;
    flex-wrap: wrap;

    &::after {
      content: '';
      flex-basis: 100%;
      height: 0;
      order: 2;
    }

    > :nth-child(3) {
      order: 3;
      margin-top: 10px;
    }
  }

  .scheduleChip {
    &#{&} {
      height: auto;
      padding: 10px 7px;
      border-width: 1.5px;
      border-radius: 10px;
      font-size: 16px;
      font-weight: 400 !important;
      line-height: 1.2;
    }
  }
}
